import { Box, Container, Stack, Typography } from '@mui/material';

import { appConfig } from '@/config/app';
import type { PublicUnitInfo } from '@/hooks/use-public-site';

interface SiteComingSoonProps {
  unit: PublicUnitInfo;
  logoUrl: string | null;
}

// Rendered instead of SitePageChrome when a site has zero published pages
// (e.g. right after a unit deletes its last page) — the org/site genuinely
// exists, so a visitor should see a friendly "coming soon" message, not a
// blank header/footer shell or the unrelated "Site Not Found" state (that
// one means the org/slug itself doesn't resolve at all).
export function SiteComingSoon({ unit, logoUrl }: SiteComingSoonProps) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: 'background.default' }}>
      <Container maxWidth="sm">
        <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center', py: 6 }}>
          {logoUrl ? (
            <Box component="img" src={logoUrl} alt="" sx={{ height: 56, width: 56, borderRadius: 1, objectFit: 'contain' }} />
          ) : null}
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {unit.name}
          </Typography>
          <Typography variant="h6" color="text.secondary">
            This site is coming soon.
          </Typography>
          <Typography color="text.secondary">
            {unit.name} hasn&apos;t published any pages yet. Check back soon.
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ pt: 2 }}>
            Powered by {appConfig.name}
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
